module.exports = __webpack_public_path__ + "static/img/lhlogo.433daf87.png";